/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useContext, useEffect, useRef } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from '@mui/material';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { FiRotateCcw, FiRotateCw } from 'react-icons/fi';
import { BsZoomIn, BsZoomOut } from 'react-icons/bs';
import 'react-advanced-cropper/dist/style.css';
import { Cropper, CropperRef, CircleStencil, RectangleStencil } from 'react-advanced-cropper';
import { LanguageContext } from '../../libs/Context';

const PreviewCropImg = (props) =>
{
	const { type, handleUploadLogoClose, intialState, onSelectFile, handleImageCrop, setCropper } = props;
	const cropperRef = useRef<CropperRef>(null);
	const { language } = useContext(LanguageContext);

	useEffect(() =>
	{
		const cropperBackgroundElements = document.querySelectorAll<HTMLElement>('.advanced-cropper__background-wrapper');

		cropperBackgroundElements.forEach((element) =>
		{
			element.style.background = 'transparent';
		});

		return () =>
		{
			cropperBackgroundElements.forEach((element) =>
			{
				element.style.background = '';
			});
		};
	}, []);

	const onCropComplete = () =>
	{
		const cropperInstance = cropperRef.current;

		if (cropperInstance)
		{
			const canvas = cropperInstance.getCanvas();

			if (canvas)
			{
				const context = canvas.getContext('2d');

				if (context)
				{
					const croppedImage = canvas.toDataURL(intialState?.file?.type || 'image/png', 0.2);

					setCropper(croppedImage);
				}
			}
		}
	};

	useEffect(() =>
	{
		setCropper(intialState?.src);
		setTimeout(onCropComplete, 200);
	}, [ intialState ]);

	const zoom = (factor) =>
	{
		if (cropperRef.current)
		{
			cropperRef.current.zoomImage(factor);
		}
	};

	const rotate = (angle: number) =>
	{
		if (cropperRef.current)
		{
			cropperRef.current.rotateImage(angle);
		}
	};

	return (
		<Dialog open>
			<DialogTitle id='scroll-dialog-title' className='dialogTitleBlock'>
				<div className='flexRow alignCntr'>
					<div className='flexMinWidthRow'>
						<span>{language?.cropImg}</span>
					</div>
					{type !== '' && (
						<div className='flexAutoRow aspectRatio4x3'>
							<span className='flexInline primaryTxt pointer'>
								<Tooltip title={'Replace image'}>
									<IconButton
										component='label'
										size='small'
										sx={{ cursor: 'pointer' }}
									>
										<input
											accept='image/x-png,image/gif,image/jpeg,image/jpg,image/png,image/*'
											className='uploadInput pointer'
											id='preview'
											type='file'
											value=''
											hidden
											onChange={(e) => onSelectFile(e, type === 'companyLogo' ? 'customLogo' : 'branding')}
										/>
										<AddPhotoAlternateIcon />
									</IconButton>
								</Tooltip>
							</span>
						</div>
					)}
				</div>
			</DialogTitle>
			<DialogContent>
				<div>
					{intialState && (
						<Cropper
							stencilComponent={type === 'companyLogo' ? CircleStencil : RectangleStencil}
							style={{ height: 400, width: 500, position: 'relative' }}
							ref={cropperRef}
							src={intialState?.src}
							className='example__cropper'
							backgroundClassName='example__cropper-background'
							onChange={onCropComplete}
						/>
					)}
				</div>
			</DialogContent>
			<div className='flexRow pdngHMD'>
				<div className='flexAutoCol alignCntr justifyCntr'>
					<span>{language?.zoom}</span>
					<div className='flexRow pdngTXXS'>
						<div className='flexInline pdngHSM'>
							<Tooltip title='Zoom-Out'>
								<BsZoomOut
									className='primaryTxt pointer'
									fontSize='var(--pixel24)'
									onClick={() => zoom(0.8)}
								/>
							</Tooltip>
						</div>
						<div className='flexInline pdngHSM'>
							<Tooltip title='Zoom-In'>
								<BsZoomIn
									className='primaryTxt pointer'
									fontSize='var(--pixel24)'
									onClick={() => zoom(1.2)}
								/>
							</Tooltip>
						</div>
					</div>
				</div>
				<div className='flexAutoCol alignCntr justifyCntr'>
					<span>{language?.rotate}</span>
					<div className='flexRow pdngTXXS'>
						<div className='flexInline pdngHSM'>
							<FiRotateCcw className='primaryTxt pointer'
								fontSize='var(--pixel24)' onClick={() => rotate(-15)}
							/>
						</div>
						<div className='flexInline pdngHSM'>
							<FiRotateCw className='primaryTxt pointer'
								fontSize='var(--pixel24)' onClick={() => rotate(15)}
							/>
						</div>
					</div>
				</div>
			</div>
			<div className='flexRow pdngBMD justifyEnd alignCntr'>
				<span>
					<Button
						variant='outlined'
						size='small'
						onClick={() => { handleUploadLogoClose(); }}
					>
						{language?.cancel}
					</Button>
				</span>
				<span className='pdngHMD'>
					<Button
						disableElevation
						disableRipple
						variant='contained'
						size='small'
						className='whiteTxt'
						onClick={() => { handleImageCrop(); }}
					>
						{language?.upload}
					</Button>
				</span>
			</div>
		</Dialog>
	);
};

export default PreviewCropImg;
